import React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import './VisitorsChart.css';

const VisitorsChart = ({ chartData, isLoading, dateRange }) => {
  const getDateRangeLabel = (range) => {
    switch (range) {
      case '7daysAgo': return 'Last 7 days';
      case '30daysAgo': return 'Last 30 days';
      case '90daysAgo': return 'Last 90 days';
      default: return 'Last 30 days';
    }
  };

  if (isLoading) {
    return (
      <div className="ga-chart-card">
        <div className="ga-chart-header">
          <div>
            <div className="ga-chart-title">Visitors over time</div>
            <div className="ga-chart-subtitle">Loading...</div>
          </div>
        </div>
        <div className="ga-chart-skeleton ga-skeleton"></div>
      </div>
    );
  }

  return (
    <div className="ga-chart-card">
      <div className="ga-chart-header">
        <div>
          <div className="ga-chart-title">Visitors over time</div>
          <div className="ga-chart-subtitle">{getDateRangeLabel(dateRange)}</div>
        </div>
      </div>
      
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 11 }}
            tickLine={false} 
            axisLine={false}
          />
          <YAxis 
            tick={{ fontSize: 11 }} 
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            contentStyle={{ 
              borderRadius: 8, 
              border: "1px solid #e5e7eb",
              fontSize: 12 
            }}
          />
          <Area 
            type="monotone" 
            dataKey="users" 
            name="Visitors"
            stroke="#4f46e5" 
            fill="#eef2ff" 
            strokeWidth={2}
          />
          <Area 
            type="monotone" 
            dataKey="sessions" 
            name="Sessions"
            stroke="#0d9488" 
            fill="#f0fdfa" 
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default VisitorsChart;